function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import * as randomstring from 'randomstring';
import { BetterSelectItem } from './better-select-item';
import { BetterSelectPortal } from './better-select-portal';
import './better-select.scss';
import { arrayContains, escapeRegExpString } from '../../utils';

var preventBubbling = function preventBubbling(event) {// if (event) { event.stopPropagation(); }
};

export var BetterSelect = /*#__PURE__*/function (_React$Component) {
  _inherits(BetterSelect, _React$Component);

  var _super = _createSuper(BetterSelect);

  function BetterSelect(props) {
    var _this;

    _classCallCheck(this, BetterSelect);

    _this = _super.call(this, props);
    _this.eid = randomstring.generate({
      length: 6
    });
    _this.defaultClassNames = ['better-select', 'bsl-container'];
    _this.ref = void 0;
    _this.dropdownRef = void 0;
    _this.searchFieldRef = void 0;
    _this.unmounting = false;
    _this.muationObserver = void 0;
    _this.defaultPlaceholder = 'Select an option';
    _this.posLoader = void 0;
    _this.state = {
      mode: _this.props.mode || 'single',
      isOpen: false,
      selectedOptions: [],
      rect: {}
    };
    return _this;
  }

  _createClass(BetterSelect, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var W, defaultValue, defaultValueSet, selectedOptions, outputValue;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                W = window;
                W.__swbdd__ = W.__swbdd__ || [];

                W.__swbdd__.push(this);

                this.wireEventHandlers();
                defaultValue = this.props.defaultValue;
                defaultValueSet = false;

                if (!(!!defaultValue && defaultValue.length > 0)) {
                  _context.next = 12;
                  break;
                }

                selectedOptions = defaultValue;

                if (_typeof(defaultValue[0]) !== 'object') {
                  selectedOptions = this.getUnnestedOptions().filter(function (opt) {
                    return _this2.props.defaultValue.indexOf(opt.value) !== -1;
                  });
                }

                _context.next = 11;
                return this.setState({
                  selectedOptions: selectedOptions
                });

              case 11:
                defaultValueSet = true;

              case 12:
                _context.next = 14;
                return this.readValueFromProps();

              case 14:
                if (defaultValueSet) {
                  outputValue = this.state.selectedOptions.map(function (opt) {
                    return opt.value;
                  });

                  if (this.props.mode !== 'multiple') {
                    if (this.state.selectedOptions.length > 0) {
                      outputValue = this.state.selectedOptions[0].value;
                    }
                  }

                  if (!!this.props.onChange) {
                    this.props.onChange(outputValue);
                  } else {
                    if (!!this.props.onClose) {
                      this.props.onClose(outputValue);
                    }
                  }
                }

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmounting = true;
      this.unwireEventHandlers();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.readValueFromProps();
    }
  }, {
    key: "readValueFromProps",
    value: function () {
      var _readValueFromProps = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var hasOptions, value, optionValues, validValues, propsValue, currentSelectionValues, stateValueSig, propsValueSig, selectedOptions;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                hasOptions = Array.isArray(this.props.options) && this.props.options.length > 0;

                if (!(hasOptions && this.props.value)) {
                  _context2.next = 14;
                  break;
                }

                value = this.state.mode === 'single' ? Array.isArray(this.props.value) ? this.props.value : [this.props.value] : this.props.value;
                optionValues = this.getUnnestedOptions().map(function (opt) {
                  return opt.value;
                });
                validValues = value.every(function (v) {
                  return arrayContains(optionValues, v);
                });

                if (!validValues) {
                  _context2.next = 14;
                  break;
                }

                propsValue = value.filter(function (v) {
                  return v !== undefined && v !== null;
                });
                currentSelectionValues = this.state.selectedOptions.map(function (opt) {
                  return opt.value;
                });
                stateValueSig = btoa(unescape(encodeURIComponent(JSON.stringify(currentSelectionValues.sort()))));
                propsValueSig = btoa(unescape(encodeURIComponent(JSON.stringify(propsValue.sort()))));

                if (!(stateValueSig !== propsValueSig)) {
                  _context2.next = 14;
                  break;
                }

                selectedOptions = this.getUnnestedOptions().filter(function (opt) {
                  return propsValue.indexOf(opt.value) !== -1;
                });
                _context2.next = 14;
                return this.setState({
                  selectedOptions: selectedOptions
                });

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function readValueFromProps() {
        return _readValueFromProps.apply(this, arguments);
      }

      return readValueFromProps;
    }()
  }, {
    key: "setState",
    value: function () {
      var _setState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(state, callback) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.unmounting) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", _get(_getPrototypeOf(BetterSelect.prototype), "setState", this).call(this, state, callback));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function setState(_x, _x2) {
        return _setState.apply(this, arguments);
      }

      return setState;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var state = this.state;
      var props = this.props;
      var handleOpenStateChange = this.handleOpenStateChange.bind(this);
      var handleOptionSearch = this.handleOptionSearch.bind(this);
      var handleSelectAllChange = this.handleSelectAllChange.bind(this);
      var allOptions = this.getUnnestedOptions();
      var visibleOptions = state.filteredOptions || this.buildFilteredOptionsArray(props.options);
      var selectedItemCount = state.selectedOptions.length;
      var allItemsSelected = selectedItemCount > 0 && state.selectedOptions.length === allOptions.length;
      var disableSelectAll = this.isMultiMode() ? props.disableSelectAll : true;
      var dropdownClassNames = ['bsl-dropdown'];

      if (selectedItemCount === 0) {
        dropdownClassNames.push('no-selections');
      }

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        ref: function ref(element) {
          return _this3.ref = element;
        },
        id: this.eid,
        className: this.buildClassNames()
      }, /*#__PURE__*/React.createElement("div", {
        className: dropdownClassNames.join(' ')
      }, /*#__PURE__*/React.createElement("div", {
        className: "bsl-dropdown-heading",
        onClick: handleOpenStateChange
      }, /*#__PURE__*/React.createElement("span", {
        className: "bsl-dropdown-title"
      }, this.buildTitle()), /*#__PURE__*/React.createElement("span", {
        className: "bsl-dropdown-loading-indicator".concat(props.loading ? ' bsl-loading' : '')
      }), /*#__PURE__*/React.createElement("span", {
        className: "bsl-dropdown-arrow ".concat(state.isOpen ? 'bsl-open' : 'bsl-closed')
      })))), /*#__PURE__*/React.createElement(BetterSelectPortal, {
        portalId: "bsl-dropdown-container-".concat(this.eid),
        className: this.buildPortalClassNames(),
        container: props.dropdownContainer || document.body
      }, this.state.isOpen && /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          return _this3.dropdownRef = el;
        },
        className: "bsl-dropdown-contents-wrapper",
        style: {
          width: state.rect.width,
          top: (state.rect.y || state.rect.top) + state.rect.height + 2,
          left: state.rect.x || state.rect.left
        }
      }, !props.disableSearch && /*#__PURE__*/React.createElement("div", {
        className: "bsl-dropdown-search"
      }, /*#__PURE__*/React.createElement("input", {
        ref: function ref(el) {
          return _this3.searchFieldRef = el;
        },
        type: "text",
        onKeyUp: function onKeyUp(ev) {
          return handleOptionSearch(ev);
        },
        placeholder: props.searchPlaceholder || 'Search'
      })), /*#__PURE__*/React.createElement("div", {
        className: "bsl-dropdown-option-list"
      }, !state.filteredOptions && !disableSelectAll && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "bsl-dropdown-option bsl-select-all".concat(allItemsSelected ? ' bsl-selected' : ''),
        onClick: handleSelectAllChange
      }, /*#__PURE__*/React.createElement("span", {
        className: "bsl-dropdown-option-label"
      }, this.props.selectAllLabel || 'Select All'), /*#__PURE__*/React.createElement("span", {
        className: "bsl-dropdown-option-toggle"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        checked: true,
        readOnly: true,
        tabIndex: -1
      }))), /*#__PURE__*/React.createElement("div", {
        className: "bsl-dropdown-divider"
      })), visibleOptions.length > 0 ? visibleOptions.map(function (option) {
        return _this3.renderOptionItem(option);
      }) : /*#__PURE__*/React.createElement("span", {
        className: "bsl-dropdown-empty"
      }, props.emptyOptionsPlaceholder || 'No options found')))));
    }
  }, {
    key: "close",
    value: function close() {
      var updateState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var isSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.state.isOpen || isSelf) {
        if (updateState) {
          this.setState({
            isOpen: false,
            filteredOptions: undefined,
            showDropdownBelow: undefined
          });
        }

        if (!!this.props.onClose) {
          var values = this.state.selectedOptions.map(function (opt) {
            return opt.value;
          });
          this.props.onClose(this.isMultiMode() ? values : values[0]);
        }
      }
    }
  }, {
    key: "getUnnestedOptions",
    value: function getUnnestedOptions() {
      var withGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (withGroups) return this.props.options;
      var opts = this.props.options.map(function (opt) {
        if (opt.options) {
          return opt.options;
        }

        return opt;
      });
      var flatOpts = opts.reduce(function (arr, val) {
        return arr.concat(val);
      }, []);
      return flatOpts;
    }
  }, {
    key: "wireEventHandlers",
    value: function wireEventHandlers() {
      var _this4 = this;

      document.addEventListener('mousedown', this.handleDocumentClick.bind(this));

      if (this.props.closeOnEscape) {
        document.addEventListener('keyup', this.handleDocumentKeyUp.bind(this));
      }

      this.ref.addEventListener('mousedown', preventBubbling);
      this.muationObserver = new MutationObserver(function () {
        _this4.setState(function () {
          return {
            rect: _this4.ref.getBoundingClientRect()
          };
        });
      });
      this.muationObserver.observe(this.ref, {
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "unwireEventHandlers",
    value: function unwireEventHandlers() {
      document.removeEventListener('mousedown', this.handleDocumentClick.bind(this));

      if (this.props.closeOnEscape) {
        document.removeEventListener('keyup', this.handleDocumentKeyUp.bind(this));
      }

      this.ref.removeEventListener('mousedown', preventBubbling);
      this.muationObserver.disconnect();
    }
  }, {
    key: "buildTitle",
    value: function buildTitle() {
      var _this5 = this;

      var selectAllLabel = (this.props.selectAllLabel || '').trim();
      var hasSelectAllLabel = !!selectAllLabel && selectAllLabel.length > 0;
      var totalSelected = this.state.selectedOptions.length;
      var allItemsSelected = totalSelected === this.getUnnestedOptions().length;
      var maxDisplayCount = this.props.maxDisplayCount || 0;
      var maxDisplayMet = maxDisplayCount > 0 && totalSelected > maxDisplayCount;
      var prefix;

      if (!!this.props.prefix && !!this.props.prefix.trim()) {
        prefix = "".concat(this.props.prefix.trim(), ": ");
      }

      var title = /*#__PURE__*/React.createElement("span", {
        className: "bsl-dropdown-placeholder"
      }, this.props.placeholder || this.defaultPlaceholder);

      if (this.state.selectedOptions.length > 0) {
        if (allItemsSelected && hasSelectAllLabel) {
          title = /*#__PURE__*/React.createElement("span", {
            className: "bsl-dropdown-selections"
          }, /*#__PURE__*/React.createElement("span", {
            className: "bsl-dropdown-selection"
          }, this.props.selectAllLabel));
        } else {
          if (maxDisplayMet) {
            title = this.handleMaxDisplayMet();
          } else {
            var selectedValues = this.state.selectedOptions.map(function (opt) {
              return opt.value;
            });
            var orderedSelections = this.getUnnestedOptions().filter(function (opt) {
              return selectedValues.indexOf(opt.value) !== -1;
            });
            title = /*#__PURE__*/React.createElement("span", {
              className: "bsl-dropdown-selections"
            }, orderedSelections.map(function (option, index) {
              return _this5.renderSelectedItem(option, index, _this5.state.selectedOptions);
            }));
          }
        }
      }

      if (this.props.disabled && !!this.props.disabledValue) {
        title = /*#__PURE__*/React.createElement("span", {
          className: "bsl-dropdown-prefix"
        }, this.props.disabledValue);
      }

      if (this.state.showInvalidMessage) {
        title = this.props.invalidValueMessage || 'Invalid Selection';
      }

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "bsl-dropdown-prefix"
      }, prefix), title);
    }
  }, {
    key: "renderSelectedItem",
    value: function renderSelectedItem(option, index, options) {
      var _this6 = this;

      if (this.props.renderSelectedItem) {
        return this.props.renderSelectedItem(option, index, options);
      }

      var isLastItem = index + 1 === options.length;
      var display = /*#__PURE__*/React.createElement("span", {
        key: option.value,
        className: "bsl-dropdown-selection"
      }, !!option.renderSelectedItem ? option.renderSelectedItem() : option.label || option.value, !isLastItem ? ', ' : '');

      if (!!this.props.theme) {
        if (this.props.theme === 'tags') {
          display = /*#__PURE__*/React.createElement("span", {
            key: option.value,
            className: "bsl-dropdown-selection bsl-tag",
            onClick: function onClick(ev) {
              return _this6.handleTagClick(ev, option);
            }
          }, !!option.renderSelectedItem ? option.renderSelectedItem() : option.label || option.value);
        }
      }

      return display;
    }
  }, {
    key: "renderOptionItem",
    value: function renderOptionItem(option) {
      var _this7 = this;

      if ('options' in option) {
        return /*#__PURE__*/React.createElement("div", {
          key: option.label,
          className: "bsl-dropdown-option-group"
        }, /*#__PURE__*/React.createElement("div", {
          className: "bsl-dropdown-option-group-label"
        }, option.label), option.options.map(function (o) {
          return _this7.renderOptionItem(o);
        }));
      }

      var currentSelectedValues = this.state.selectedOptions.map(function (opt) {
        return opt.value;
      });
      var itemIsSelected = currentSelectedValues.indexOf(option.value) !== -1;
      var handleItemChange = this.handleItemChange.bind(this);
      return /*#__PURE__*/React.createElement(BetterSelectItem, {
        key: option.value,
        value: option.value,
        label: option.label,
        checked: itemIsSelected,
        onChange: handleItemChange,
        renderOptionItem: this.props.renderOptionItem,
        disabled: option.disabled
      });
    }
  }, {
    key: "handleTagClick",
    value: function () {
      var _handleTagClick = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(ev, option) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (ev) {
                  ev.preventDefault();
                  ev.stopPropagation();
                }

                if (!this.props.disabled) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                return _context4.abrupt("return", this.setState(function (_ref) {
                  var selectedOptions = _ref.selectedOptions;
                  selectedOptions = selectedOptions.filter(function (o) {
                    return o.value !== option.value;
                  });
                  return {
                    selectedOptions: selectedOptions
                  };
                }));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleTagClick(_x3, _x4) {
        return _handleTagClick.apply(this, arguments);
      }

      return handleTagClick;
    }()
  }, {
    key: "handleMaxDisplayMet",
    value: function handleMaxDisplayMet() {
      var selectedOptions = this.state.selectedOptions;

      if (this.props.maxDisplayFormatter) {
        return this.props.maxDisplayFormatter(selectedOptions);
      }

      var multi = selectedOptions.length > 1;
      return "".concat(selectedOptions.length, " ").concat(multi ? 'Items' : 'Item', " Selected");
    }
  }, {
    key: "handleSelectAllChange",
    value: function handleSelectAllChange() {
      var _this8 = this;

      var allItemsSelected = this.state.selectedOptions.length === this.getUnnestedOptions().length;
      var selectedOptions = [];

      if (!allItemsSelected) {
        selectedOptions = this.getUnnestedOptions();
      }

      this.setState(function () {
        return {
          selectedOptions: selectedOptions
        };
      }, function () {
        if (_this8.props.onChange) {
          var values = selectedOptions.map(function (opt) {
            return opt.value;
          });

          _this8.props.onChange(values);
        }
      });
    }
  }, {
    key: "handleItemChange",
    value: function handleItemChange(option, checked) {
      var _this9 = this;

      this.setState(function (_ref2) {
        var selectedOptions = _ref2.selectedOptions,
            isOpen = _ref2.isOpen;

        if (_this9.isMultiMode()) {
          var optionIndex = selectedOptions.findIndex(function (opt) {
            return opt.value === option.value;
          });

          if (checked) {
            if (optionIndex === -1) {
              selectedOptions.push(option);
            }
          } else {
            if (optionIndex !== -1) {
              selectedOptions.splice(optionIndex, 1);
            }
          }

          return {
            isOpen: isOpen,
            selectedOptions: selectedOptions
          };
        }

        return {
          isOpen: !isOpen,
          selectedOptions: [option]
        };
      }, function () {
        if (_this9.props.onChange) {
          var opts = _this9.state.selectedOptions;
          var values = opts.map(function (opt) {
            return opt.value;
          });

          _this9.props.onChange(_this9.isMultiMode() ? values : values[0], _this9.isMultiMode() ? opts : opts[0]);
        }
      });
    }
  }, {
    key: "handleOpenStateChange",
    value: function () {
      var _handleOpenStateChange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(ev) {
        var _this10 = this;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if ('preventDefault' in ev) {
                  ev.preventDefault();
                  ev.stopPropagation();

                  if ('nativeEvent' in ev) {
                    ev.nativeEvent.preventDefault();
                    ev.nativeEvent.stopPropagation();
                  }
                }

                if (!this.props.disabled) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return");

              case 3:
                _context5.next = 5;
                return this.setState(function (_ref3) {
                  var isOpen = _ref3.isOpen,
                      filteredOptions = _ref3.filteredOptions,
                      showDropdownBelow = _ref3.showDropdownBelow;
                  return {
                    isOpen: !isOpen,
                    filteredOptions: isOpen ? undefined : filteredOptions,
                    showDropdownBelow: !isOpen ? undefined : showDropdownBelow,
                    rect: _this10.ref.getBoundingClientRect()
                  };
                });

              case 5:
                if (this.state.isOpen) {
                  this.closeOtherDropdowns();

                  if (!this.props.disableSearch) {
                    setTimeout(function () {
                      return _this10.searchFieldRef.focus();
                    }, 50);
                  }
                } else {
                  this.close(false, true);
                }

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function handleOpenStateChange(_x5) {
        return _handleOpenStateChange.apply(this, arguments);
      }

      return handleOpenStateChange;
    }()
  }, {
    key: "closeOtherDropdowns",
    value: function closeOtherDropdowns() {
      var _this11 = this;

      var W = window;

      if (!!W.__swbdd__) {
        W.__swbdd__.filter(function (dd) {
          return dd.eid !== _this11.eid;
        }).forEach(function (dd) {
          return dd.close();
        });
      }
    }
  }, {
    key: "buildClassNames",
    value: function buildClassNames() {
      var classNames = _toConsumableArray(this.defaultClassNames);

      if (this.props.loading === true) {
        classNames.push('bsl-loading');
      }

      classNames.push(this.state.isOpen ? 'bsl-open' : 'bsl-closed');
      var size = this.props.size || 'default';
      classNames.push("bsl-size-".concat(size.toLowerCase()));

      if (!!this.props.theme) {
        classNames.push("theme-".concat(this.props.theme));
      }

      if (!!this.props.skeletonMode) {
        classNames.push('skeleton');
      }

      if (this.props.className && this.props.className.trim() !== '') {
        classNames.push(this.props.className.trim());
      }

      if (this.props.disabled) {
        classNames.push('bsl-disabled');
      }

      return classNames.join(' ');
    }
  }, {
    key: "buildPortalClassNames",
    value: function buildPortalClassNames() {
      var _this12 = this;

      var classNames = [];

      if (this.props.loading === true) {
        classNames.push('bsl-loading');
      }

      var size = this.props.size || 'default';
      classNames.push("bsl-size-".concat(size.toLowerCase()));

      if (!!this.props.theme) {
        classNames.push("theme-".concat(this.props.theme));
      }

      if (!!this.props.dropdownClassName) {
        classNames.push(this.props.dropdownClassName);
      }

      if (this.props.disabled) {
        classNames.push('bsl-disabled');
      }

      var docRect = document.body.getBoundingClientRect();

      if (this.state.showDropdownBelow === undefined) {
        classNames.push('pos-loading');
      } else if (!this.state.showDropdownBelow) {
        classNames.push('pos-above');
      }

      if (!this.props.loading && this.state.showDropdownBelow === undefined) {
        if (!!this.posLoader) clearTimeout(this.posLoader);
        this.posLoader = setTimeout(function () {
          if (!!_this12.dropdownRef) {
            var ddRect = _this12.dropdownRef.getBoundingClientRect();

            var ddBottomDiff = docRect.bottom - ddRect.bottom;
            var ddShowBelow = ddBottomDiff > 5;

            if (ddShowBelow) {
              if (_this12.state.showDropdownBelow !== true) {
                _this12.setState({
                  showDropdownBelow: true
                });
              }
            } else {
              if (_this12.state.showDropdownBelow !== false) {
                _this12.setState({
                  showDropdownBelow: false
                });
              }
            }
          }
        }, 50);
      }

      return classNames.join(' ');
    }
  }, {
    key: "buildFilteredOptionsArray",
    value: function buildFilteredOptionsArray(options) {
      var _this13 = this;

      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        return true;
      };
      var seed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      options.forEach(function (opt) {
        if ('options' in opt) {
          var group = {
            label: opt.label,
            value: opt.label,
            disabled: opt.disabled,
            options: _this13.buildFilteredOptionsArray(opt.options, filter)
          };

          if (group.options.length > 0) {
            seed.push(group);
          }
        } else {
          if (filter(opt)) {
            seed.push(opt);
          }
        }
      });
      return seed;
    }
  }, {
    key: "handleOptionSearch",
    value: function handleOptionSearch(event) {
      var target = event.target;
      var searchValue = !!target.value ? target.value.trim() : undefined;
      var allOptions = this.props.options;
      var filteredOptions;

      if (searchValue && searchValue.length > 0) {
        var searchRgx = new RegExp(escapeRegExpString(searchValue), 'i');
        filteredOptions = this.buildFilteredOptionsArray(allOptions, function (opt) {
          var value = opt.value || '';
          var label = opt.label || value;
          return searchRgx.test(label.toString()) || searchRgx.test(value.toString());
        });
      }

      this.setState(function () {
        return {
          filteredOptions: filteredOptions
        };
      });
    }
  }, {
    key: "handleDocumentKeyUp",
    value: function handleDocumentKeyUp(event) {
      if (this.state.isOpen) {
        if (event.key && event.key.toUpperCase() === 'ESCAPE') {
          preventBubbling(event);
          this.close();
        }
      }
    }
  }, {
    key: "handleDocumentClick",
    value: function handleDocumentClick(event) {
      if (this.state.isOpen) {
        var shouldExecute = true;

        if (!!event.target) {
          var target = event.target;

          if ('classList' in target) {
            if (/bsl-/i.test(target.classList.toString())) {
              shouldExecute = false;
            }
          }
        }

        if (shouldExecute) {
          this.close();
        }
      }
    }
  }, {
    key: "isMultiMode",
    value: function isMultiMode() {
      return this.state.mode === 'multiple';
    }
  }]);

  return BetterSelect;
}(React.Component);